import { Link } from "react-router-dom";
import { App } from "/app/src/models/app";
import { useTranslation } from "react-i18next";
import { Col } from "antd";
import { HeroChip } from "../HeroUi/Chip";

/**
 * Component to display a single app box in the app list
 */
export default function AppBox({
  app,
  availableApp,
}: {
  app: App;
  availableApp: boolean;
}) {
  const appSelector = `${app.name.replace(" ", "_").toLowerCase()}`;
  const formattedAppSelector = `${appSelector}_app`;
  const { t } = useTranslation();

  return (
    <Col
      xs={{ span: 24 }}
      sm={{ span: 24 }}
      md={{ span: 12 }}
      lg={{ span: 8 }}
      xl={{ span: 6 }}
    >
      <div
        className={availableApp ? "appBox" : "appBox disabled_app"}
        id={formattedAppSelector}
      >
        <div className="icon" />
        <div className="info">
          {availableApp ? (
            <h3 className="flex items-center space-x-2">
              <Link to={`/apps/${app.id}`}>
                {t(`translation:${appSelector}`, appSelector)}
              </Link>
              {app.name === "Order Processor" && (
                <HeroChip size="sm" color="secondary" variant="shadow">
                  {t("translation:beta")}
                </HeroChip>
              )}
            </h3>
          ) : (
            <h3>{t(`translation:${appSelector}`, appSelector)}</h3>
          )}
          {app.description}
        </div>
      </div>
    </Col>
  );
}
